import React, { useContext, useEffect, useState } from 'react';
import CurrentPageContext from '@/components/context/CurrentPageData';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { useRouter } from 'next/router';
import Header from '@/components/03_organisms/GlobalHeader/Header';
import GlobalFooter from '@/components/03_organisms/GlobalFooter/Footer';
import PotnetsHeader from '@/components/03_organisms/GlobalHeader/HeaderPotnets';
import PotnetsFooter from '@/components/03_organisms/GlobalFooter/FooterPotnets';
import { makeStyles } from '@material-ui/core';
import { useMediaQuery } from 'react-responsive';


const useStyles = makeStyles((theme) => ({
  headerWrapper: {
    height: 0,
  },
  contentBox: {
    'maxWidth': '1400px',
    'margin': '0 auto',
    paddingLeft: 78,
    paddingRight: 78,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 40,
      paddingRight: 40,
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
}));
const GlobalLayout = (props) => {
  const isLargeScreen = useMediaQuery({ minWidth: 768 });
  const router = useRouter();
  const classes = useStyles();
  const { menu, footermenu, blocks, layout, children } = props;
  const sitewideContext = useContext(CurrentPageContext);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    if (router.pathname !== '/') return;

    const handleScroll = () => {
      if (window.scrollY > window.innerHeight) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [router.pathname]);
  return (
    <>
      {/* {!router?.pathname?.includes('/thank-you-contacting-baywood-greens') && ( */}
      <header id="site-header">
        {/* {sitewideContext?.site == 'baywoods' && */}
        {sitewideContext?.site == 'baywoods' &&
          (router.pathname === '/' ? (
            <>
          <div
  style={
    isLargeScreen
      ? {
          position: 'absolute',
          zIndex: 1000,
          backgroundColor: scrolled ? 'white' : 'transparent',
          transition: 'background-color 0.3s ease',
          width: '100%',
        }
      : {}
  }
>
                <Header menu={menu} />
              </div>
              <div className={classes.headerWrapper} />
            </>
          ) : (
            <Header menu={menu} />
          ))}
        {/* } */}
        {sitewideContext?.site == 'potnets' && (
          <PotnetsHeader menu={menu}></PotnetsHeader>
        )}
      </header>
      {/* )} */}

      <Box
        className={
          router.pathname === '/' || router.pathname.includes('/programs')
            ? ''
            : classes.contentBox
        }
      >
        {children}
      </Box>
      {Object.keys(blocks).length > 0 && (
        <div className="reactjs-sidebar">
          {Object.entries(blocks).map(([key, block]) => {
            if (
              block.region == 'react_sidebar' &&
              block.data &&
              block.data.body &&
              block.data.body[0]
            ) {
              return (
                <div
                  className={`block-id-${key}`}
                  key={`react-block-sidebar-${key}`}
                  dangerouslySetInnerHTML={{
                    __html: block.data.body[0]['#text'],
                  }}
                ></div>
              );
            } else if (block.region == 'react_sidebar' && block.data) {
              return (
                <div
                  className={`block-id-${key}`}
                  key={`react-block-sidebar-${key}`}
                  dangerouslySetInnerHTML={{ __html: block.data }}
                ></div>
              );
            }
          })}
        </div>
      )}
      {/* <div className="content-main-wrapper" id="main-content">
        <Container>{children}</Container>
      </div> */}

      {!router?.pathname?.includes('/thank-you-contacting-baywood-greens') && (
        <>
          {sitewideContext?.site == 'baywoods' && (
            <GlobalFooter menu={footermenu} />
          )}
          {sitewideContext?.site == 'potnets' && (
            <PotnetsFooter menu={footermenu} />
          )}
        </>
      )}
    </>
  );
};

GlobalLayout.propTypes = {
  menu: PropTypes.object,
  blocks: PropTypes.object,
};

GlobalLayout.defaultProps = {
  blocks: {},
};

export default GlobalLayout;
